import { Download } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

import { Button } from '@bliks-io/ui';
import { useOrganization, useExportData } from '@/api/queries/useOrganization';
import { toastApiError } from '@/api/mutations/toast-api-error';
import { downloadBlob } from '@/lib/file-utils';

export function BackendDataExportButton() {
  const { t } = useTranslation();
  const { data: org } = useOrganization();
  const exportData = useExportData();

  async function handleExportDataZip() {
    if (!org) {
      toast.error(t('common.Error') || 'Organization not found');
      return;
    }

    try {
      const { blob, filename } = await exportData.mutateAsync();
      downloadBlob(blob, filename);

      toast.success(t('OrgSettingPage.ExportDataSuccess') || 'Data exported successfully');
    } catch (error) {
      toastApiError(error, 'common.Error');
    }
  }

  return (
    <Button variant="secondary" loading={exportData.isPending} onClick={handleExportDataZip}>
      <Download className="mr-2 h-4 w-4" />
      {t('OrgSettingPage.ExportData')}
    </Button>
  );
}
